/**
 * @interface
 * @param {Foundation.Form} form
 */
Foundation.Form.Validator = function (form) {};

/**
 * The name of the validation. This is what you put in the data-validate
 * attribute to activiate a particular validation, so it should be all
 * lower case and be alpha-numeric with no spaces.
 * @return {string}
 */
Foundation.Form.Validator.prototype.identifier = function () {};

/**
 * Returns a promise that is fulfilled when validation passes, and failed when
 * validation has not passed. On failure, the validator must populate the
 * "errors" field of the promise with an array containing either strings
 * with error messages, or objects with a "message" field containg the error
 * string, and a "name" field containing an array of the names of the fields
 * with the errors.
 * @param {jQuery} fieldElements
 * @return {Foundation.Promise}
 */
Foundation.Form.Validator.prototype.validate = function (fieldElements) {};

/* eslint no-unused-vars: "off" */
